// United states
const DEFAULT_LOCATION = {
  lat: 37.09024,
  lng: -95.712891,
}

const MAP_CIRCLE_OPTIONS = {
  zIndex: 1,
  radius: 0,
  visible: true,
  strokeWeight: 1,
  editable: false,
  clickable: false,
  strokeOpacity: 1,
  draggable: false,
  fillOpacity: 0.278,
  strokeColor: 'white',
  fillColor: '#FF0000',
}

const AUTO_COMPLETE_INPUT_OPTIONS = {
  types: [],
  fields: ['address_components', 'geometry.location', 'place_id', 'formatted_address'],
}

const ONE_MILE = 1609.34

const MAP_CONSTS = {
  DEFAULT_LOCATION,
  AUTO_COMPLETE_INPUT_OPTIONS,
  MAP_CIRCLE_OPTIONS,
  ONE_MILE,
}

export default MAP_CONSTS
